import { Loader, Stack } from "@mantine/core";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { useRouterState } from "@tanstack/react-router";

function formatQueryKey(queryKey: readonly unknown[]) {
	try {
		return JSON.stringify(queryKey);
	} catch {
		return String(queryKey);
	}
}

const PageLoading: React.FC<{ details?: string }> = ({ details }) => {
    return (
        <Stack
            w="100%"
            h="100%"
            bg="var(--mantine-color-body)"
            justify="center"
            align="center"
        >
            <Loader size="xl" type="bars" />
            {details && <div style={{ marginTop: 10 }}>{details}</div>}
        </Stack>
    )
}

export function RoutePendingIndicator() {
	const queryClient = useQueryClient();
	const fetchingCount = useIsFetching();
	const pendingRouteIds = useRouterState({
		select: (state) =>
			state.matches
				.filter((match) => match.status === "pending")
				.map((match) => match.routeId),
	});

	if (!import.meta.env.DEV) {
		return <PageLoading />;
	}

	const fetchingQueryKeys = fetchingCount
		? queryClient
				.getQueryCache()
				.getAll()
				.filter((query) => query.state.fetchStatus === "fetching")
				.map((query) => formatQueryKey(query.queryKey))
		: [];

	const details = [
		pendingRouteIds.length ? `routes: ${pendingRouteIds.join(", ")}` : null,
		fetchingQueryKeys.length
			? `queries: ${fetchingQueryKeys.join(", ")}`
			: "queries: none (router/module loading)",
	]
		.filter(Boolean)
		.join(" · ");

	return <PageLoading details={details} />;
}
